import { render } from "./MsgHolder.vue?vue&type=template&id=3006bca8"
import script from "./MsgHolder.vue?vue&type=script&lang=js"
export * from "./MsgHolder.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__